/**
 * 학교일람 데이터
 */
const SchoolCatalogueData = [
    {
        "book_id": 10398,
        "book_title": "監理敎會協成神學校一覽 自1924年至1925年",
        "book_title_ko": "감리교회협성신학교일람 자1924년지1925년",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "監理敎會協成神學校",
        "publisher_ko": "감리교회협성신학교",
        "library": "△",
        "school_id": 52940,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10398,
        "book_title": "監理敎會協成神學校一覽 自1924年至1925年",
        "book_title_ko": "감리교회협성신학교일람 자1924년지1925년",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "監理敎會協成神學校",
        "publisher_ko": "감리교회협성신학교",
        "library": "△",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10399,
        "book_title": "監理敎會協成神學校一覽 自1925年至1926年",
        "book_title_ko": "감리교회협성신학교일람 자1925년지1926년",
        "publish_date": "1925.00.00",
        "publish_year": 1925,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "監理敎會協成神學校",
        "publisher_ko": "감리교회협성신학교",
        "library": "△",
        "school_id": 52940,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10399,
        "book_title": "監理敎會協成神學校一覽 自1925年至1926年",
        "book_title_ko": "감리교회협성신학교일람 자1925년지1926년",
        "publish_date": "1925.00.00",
        "publish_year": 1925,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "監理敎會協成神學校",
        "publisher_ko": "감리교회협성신학교",
        "library": "△",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10400,
        "book_title": "예수敎長老會朝鮮神學校 設立槪要 ",
        "book_title_ko": "예수교장로회조선신학교 설립개요 ",
        "publish_date": "1939.06.05",
        "publish_year": 1939,
        "publish_month": 6,
        "publish_day": 5,
        "publisher": "蔡弼近 長老會神學校 設立期成會",
        "publisher_ko": "채필근 장로회신학교 설립기성회",
        "library": "연세대",
        "school_id": 52771,
        "primaryname": "예수敎長老會朝鮮神學校",
        "primaryname_ko": "예수敎長老會朝鮮神學校"
    },
    {
        "book_id": 10422,
        "book_title": "(釜山高等女學校) 釜山公立高等女學校一覽 第3回",
        "book_title_ko": "(부산고등여학교) 부산공립고등여학교일람 제3회",
        "publish_date": "1915.00.00",
        "publish_year": 1915,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "釜山公立高等女學校",
        "publisher_ko": "부산공립고등여학교",
        "library": "국사편찬위원회",
        "school_id": 52944,
        "primaryname": "釜山公立高等女學校",
        "primaryname_ko": "부산공립고등여학교"
    },
    {
        "book_id": 10422,
        "book_title": "(釜山高等女學校) 釜山公立高等女學校一覽 第3回",
        "book_title_ko": "(부산고등여학교) 부산공립고등여학교일람 제3회",
        "publish_date": "1915.00.00",
        "publish_year": 1915,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "釜山公立高等女學校",
        "publisher_ko": "부산공립고등여학교",
        "library": "국사편찬위원회",
        "school_id": 52786,
        "primaryname": "釜山高等女學校",
        "primaryname_ko": "부산고등여학교"
    },
    {
        "book_id": 10545,
        "book_title": "(京城第一高等普通學校) 京城第一公立高等普通學校一覽 大正15年8月調",
        "book_title_ko": "(경성제일고등보통학교) 경성제일공립고등보통학교일람 대정15년8월조",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "",
        "publisher_ko": "",
        "library": "",
        "school_id": 52802,
        "primaryname": "京城第一高等普通學校",
        "primaryname_ko": "경성제일고등보통학교"
    },
    {
        "book_id": 10546,
        "book_title": "高敞高等普通學校一覽 ",
        "book_title_ko": "고창고등보통학교일람 ",
        "publish_date": "1934.09.00",
        "publish_year": 1934,
        "publish_month": 9,
        "publish_day": 0,
        "publisher": "高敞高等普通學校",
        "publisher_ko": "고창고등보통학교",
        "library": "서울대○",
        "school_id": 42631,
        "primaryname": "高敞高等普通學校",
        "primaryname_ko": "고창고등보통학교"
    },
    {
        "book_id": 10546,
        "book_title": "高敞高等普通學校一覽 ",
        "book_title_ko": "고창고등보통학교일람 ",
        "publish_date": "1934.09.00",
        "publish_year": 1934,
        "publish_month": 9,
        "publish_day": 0,
        "publisher": "高敞高等普通學校",
        "publisher_ko": "고창고등보통학교",
        "library": "서울대○",
        "school_id": 52803,
        "primaryname": "高敞高等普通學校",
        "primaryname_ko": "고창고등보통학교"
    },
    {
        "book_id": 10612,
        "book_title": "官立漢城外國語學校一覽 隆熙3年3月",
        "book_title_ko": "관립한성외국어학교일람 융희3년3월",
        "publish_date": "1909.03.00",
        "publish_year": 1909,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "官立漢城外國語學校",
        "publisher_ko": "관립한성외국어학교",
        "library": "국립중앙도서관",
        "school_id": 34134,
        "primaryname": "官立漢城外國語學校",
        "primaryname_ko": null
    },
    {
        "book_id": 10612,
        "book_title": "官立漢城外國語學校一覽 隆熙3年3月",
        "book_title_ko": "관립한성외국어학교일람 융희3년3월",
        "publish_date": "1909.03.00",
        "publish_year": 1909,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "官立漢城外國語學校",
        "publisher_ko": "관립한성외국어학교",
        "library": "국립중앙도서관",
        "school_id": 52826,
        "primaryname": "官立漢城外國語學校",
        "primaryname_ko": "관립한성외국어학교"
    },
    {
        "book_id": 10613,
        "book_title": "大韓醫院附屬醫學校一覽 ",
        "book_title_ko": "대한의원부속의학교일람 ",
        "publish_date": "1909.00.00",
        "publish_year": 1909,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "",
        "publisher_ko": "",
        "library": "△",
        "school_id": 52827,
        "primaryname": "大韓醫院附屬醫學校",
        "primaryname_ko": "대한의원부속의학교"
    },
    {
        "book_id": 10622,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1927.00.00",
        "publish_year": 1927,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10622,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1927.00.00",
        "publish_year": 1927,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10623,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1929.00.00",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10623,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1929.00.00",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10624,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1930.00.00",
        "publish_year": 1930,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10624,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1930.00.00",
        "publish_year": 1930,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10625,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10625,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10626,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1932.00.00",
        "publish_year": 1932,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10626,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1932.00.00",
        "publish_year": 1932,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10627,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10627,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10628,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10628,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10629,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10629,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10630,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10630,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10631,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10631,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10632,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관△",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10632,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관△",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10633,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1939.00.00",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10633,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1939.00.00",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10634,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10634,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10635,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관△",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10635,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관△",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10636,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1942.00.00",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관△",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10636,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1942.00.00",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관△",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10637,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10637,
        "book_title": "京城帝國大學一覽 ",
        "book_title_ko": "경성제국대학일람 ",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "국립중앙도서관",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10638,
        "book_title": "京城帝國大學一覽 (自昭和2年 至昭和3年)",
        "book_title_ko": "경성제국대학일람 (자소화2년 지소화3년)",
        "publish_date": "1928.00.00",
        "publish_year": 1928,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 2377,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10638,
        "book_title": "京城帝國大學一覽 (自昭和2年 至昭和3年)",
        "book_title_ko": "경성제국대학일람 (자소화2년 지소화3년)",
        "publish_date": "1928.00.00",
        "publish_year": 1928,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學",
        "publisher_ko": "경성제국대학",
        "library": "△",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10659,
        "book_title": "京城帝國大學豫科一覽 ",
        "book_title_ko": "경성제국대학예과일람 ",
        "publish_date": "1926.00.00",
        "publish_year": 1926,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學 豫科",
        "publisher_ko": "경성제국대학 예과",
        "library": "",
        "school_id": 52963,
        "primaryname": "京城帝國大學 豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10659,
        "book_title": "京城帝國大學豫科一覽 ",
        "book_title_ko": "경성제국대학예과일람 ",
        "publish_date": "1926.00.00",
        "publish_year": 1926,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學 豫科",
        "publisher_ko": "경성제국대학 예과",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10660,
        "book_title": "京城帝國大學豫科一覽 大正13年",
        "book_title_ko": "경성제국대학예과일람 대정13년",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學 豫科",
        "publisher_ko": "경성제국대학 예과",
        "library": "국립중앙도서관",
        "school_id": 52963,
        "primaryname": "京城帝國大學 豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10660,
        "book_title": "京城帝國大學豫科一覽 大正13年",
        "book_title_ko": "경성제국대학예과일람 대정13년",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城帝國大學 豫科",
        "publisher_ko": "경성제국대학 예과",
        "library": "국립중앙도서관",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10661,
        "book_title": "京城帝國大學豫科一覽 昭和4年",
        "book_title_ko": "경성제국대학예과일람 소화4년",
        "publish_date": "1929.08.26",
        "publish_year": 1929,
        "publish_month": 8,
        "publish_day": 26,
        "publisher": "京城帝國大學 豫科",
        "publisher_ko": "경성제국대학 예과",
        "library": "",
        "school_id": 52963,
        "primaryname": "京城帝國大學 豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10661,
        "book_title": "京城帝國大學豫科一覽 昭和4年",
        "book_title_ko": "경성제국대학예과일람 소화4년",
        "publish_date": "1929.08.26",
        "publish_year": 1929,
        "publish_month": 8,
        "publish_day": 26,
        "publisher": "京城帝國大學 豫科",
        "publisher_ko": "경성제국대학 예과",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10662,
        "book_title": "京城帝國大學豫科一覽 昭和5年",
        "book_title_ko": "경성제국대학예과일람 소화5년",
        "publish_date": "1930.08.10",
        "publish_year": 1930,
        "publish_month": 8,
        "publish_day": 10,
        "publisher": "京城帝國大學 豫科",
        "publisher_ko": "경성제국대학 예과",
        "library": "",
        "school_id": 52963,
        "primaryname": "京城帝國大學 豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10662,
        "book_title": "京城帝國大學豫科一覽 昭和5年",
        "book_title_ko": "경성제국대학예과일람 소화5년",
        "publish_date": "1930.08.10",
        "publish_year": 1930,
        "publish_month": 8,
        "publish_day": 10,
        "publisher": "京城帝國大學 豫科",
        "publisher_ko": "경성제국대학 예과",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10672,
        "book_title": "京城師範學校總覽 ",
        "book_title_ko": "경성사범학교총람 ",
        "publish_date": "1929.00.00",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城師範學校",
        "publisher_ko": "경성사범학교",
        "library": "",
        "school_id": 1847,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10672,
        "book_title": "京城師範學校總覽 ",
        "book_title_ko": "경성사범학교총람 ",
        "publish_date": "1929.00.00",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城師範學校",
        "publisher_ko": "경성사범학교",
        "library": "",
        "school_id": 52831,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10673,
        "book_title": "京城師範學校總覽 ",
        "book_title_ko": "경성사범학교총람 ",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城師範學校",
        "publisher_ko": "경성사범학교",
        "library": "서울대",
        "school_id": 1847,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10673,
        "book_title": "京城師範學校總覽 ",
        "book_title_ko": "경성사범학교총람 ",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城師範學校",
        "publisher_ko": "경성사범학교",
        "library": "서울대",
        "school_id": 52831,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10862,
        "book_title": "京城高等工業學校一覽 ",
        "book_title_ko": "경성고등공업학교일람 ",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城高等工業學校",
        "publisher_ko": "경성고등공업학교",
        "library": "△",
        "school_id": 1842,
        "primaryname": "京城高等工業學校",
        "primaryname_ko": "경성고등공업학교"
    },
    {
        "book_id": 10862,
        "book_title": "京城高等工業學校一覽 ",
        "book_title_ko": "경성고등공업학교일람 ",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城高等工業學校",
        "publisher_ko": "경성고등공업학교",
        "library": "△",
        "school_id": 52895,
        "primaryname": "京城高等工業學校",
        "primaryname_ko": "경성고등공업학교"
    },
    {
        "book_id": 10863,
        "book_title": "京城高等工業學校一覽 自大正13年 至大正14年",
        "book_title_ko": "경성고등공업학교일람 자대정13년 지대정14년",
        "publish_date": "1924.05.31",
        "publish_year": 1924,
        "publish_month": 5,
        "publish_day": 31,
        "publisher": "京城高等工業學校",
        "publisher_ko": "경성고등공업학교",
        "library": "국립중앙도서관",
        "school_id": 1842,
        "primaryname": "京城高等工業學校",
        "primaryname_ko": "경성고등공업학교"
    },
    {
        "book_id": 10863,
        "book_title": "京城高等工業學校一覽 自大正13年 至大正14年",
        "book_title_ko": "경성고등공업학교일람 자대정13년 지대정14년",
        "publish_date": "1924.05.31",
        "publish_year": 1924,
        "publish_month": 5,
        "publish_day": 31,
        "publisher": "京城高等工業學校",
        "publisher_ko": "경성고등공업학교",
        "library": "국립중앙도서관",
        "school_id": 52895,
        "primaryname": "京城高等工業學校",
        "primaryname_ko": "경성고등공업학교"
    },
    {
        "book_id": 10864,
        "book_title": "京城女子醫學專門學校一覽 ",
        "book_title_ko": "경성여자의학전문학교일람 ",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城女子醫學專門學校",
        "publisher_ko": "경성여자의학전문학교",
        "library": "△",
        "school_id": 49087,
        "primaryname": "京城女子醫學專門學校",
        "primaryname_ko": "경성여자의학전문학교"
    },
    {
        "book_id": 10864,
        "book_title": "京城女子醫學專門學校一覽 ",
        "book_title_ko": "경성여자의학전문학교일람 ",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城女子醫學專門學校",
        "publisher_ko": "경성여자의학전문학교",
        "library": "△",
        "school_id": 52910,
        "primaryname": "京城女子醫學專門學校",
        "primaryname_ko": "경성여자의학전문학교"
    },
    {
        "book_id": 10865,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1927.00.00",
        "publish_year": 1927,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 19040,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10865,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1927.00.00",
        "publish_year": 1927,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 52911,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10866,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1928.00.00",
        "publish_year": 1928,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 19040,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10866,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1928.00.00",
        "publish_year": 1928,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 52911,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10867,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1929.00.00",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 19040,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10867,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1929.00.00",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 52911,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10868,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1930.00.00",
        "publish_year": 1930,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 19040,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10868,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1930.00.00",
        "publish_year": 1930,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 52911,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10869,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 19040,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10869,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관△",
        "school_id": 52911,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10870,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1932.00.00",
        "publish_year": 1932,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관",
        "school_id": 19040,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10870,
        "book_title": "京城醫學專門學校一覽 ",
        "book_title_ko": "경성의학전문학교일람 ",
        "publish_date": "1932.00.00",
        "publish_year": 1932,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "일본국립국회도서관",
        "school_id": 52911,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10871,
        "book_title": "京城醫學專門學校一覽 大正13年",
        "book_title_ko": "경성의학전문학교일람 대정13년",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 19040,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10871,
        "book_title": "京城醫學專門學校一覽 大正13年",
        "book_title_ko": "경성의학전문학교일람 대정13년",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 52911,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10872,
        "book_title": "京城醫學專門學校一覽 大正14年",
        "book_title_ko": "경성의학전문학교일람 대정14년",
        "publish_date": "1925.00.00",
        "publish_year": 1925,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 19040,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10872,
        "book_title": "京城醫學專門學校一覽 大正14年",
        "book_title_ko": "경성의학전문학교일람 대정14년",
        "publish_date": "1925.00.00",
        "publish_year": 1925,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 52911,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10873,
        "book_title": "京城醫學專門學校一覽 大正15年",
        "book_title_ko": "경성의학전문학교일람 대정15년",
        "publish_date": "1926.00.00",
        "publish_year": 1926,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 19040,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10873,
        "book_title": "京城醫學專門學校一覽 大正15年",
        "book_title_ko": "경성의학전문학교일람 대정15년",
        "publish_date": "1926.00.00",
        "publish_year": 1926,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城醫學專門學校",
        "publisher_ko": "경성의학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 52911,
        "primaryname": "京城醫學專門學校",
        "primaryname_ko": "경성의학전문학교"
    },
    {
        "book_id": 10874,
        "book_title": "京城法學專門學校一覽 ",
        "book_title_ko": "경성법학전문학교일람 ",
        "publish_date": "1923.00.00",
        "publish_year": 1923,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城法學專門學校",
        "publisher_ko": "경성법학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 20088,
        "primaryname": "京城法學專門學校",
        "primaryname_ko": "경성법학전문학교"
    },
    {
        "book_id": 10874,
        "book_title": "京城法學專門學校一覽 ",
        "book_title_ko": "경성법학전문학교일람 ",
        "publish_date": "1923.00.00",
        "publish_year": 1923,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城法學專門學校",
        "publisher_ko": "경성법학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 52898,
        "primaryname": "京城法學專門學校",
        "primaryname_ko": "경성법학전문학교"
    },
    {
        "book_id": 10875,
        "book_title": "京城法學專門學校一覽 ",
        "book_title_ko": "경성법학전문학교일람 ",
        "publish_date": "1925.00.00",
        "publish_year": 1925,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城法學專門學校",
        "publisher_ko": "경성법학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 20088,
        "primaryname": "京城法學專門學校",
        "primaryname_ko": "경성법학전문학교"
    },
    {
        "book_id": 10875,
        "book_title": "京城法學專門學校一覽 ",
        "book_title_ko": "경성법학전문학교일람 ",
        "publish_date": "1925.00.00",
        "publish_year": 1925,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城法學專門學校",
        "publisher_ko": "경성법학전문학교",
        "library": "국립중앙도서관△",
        "school_id": 52898,
        "primaryname": "京城法學專門學校",
        "primaryname_ko": "경성법학전문학교"
    },
    {
        "book_id": 10876,
        "book_title": "京城高等商業學校一覽 大正12年度",
        "book_title_ko": "경성고등상업학교일람 대정12년도",
        "publish_date": "1923.10.05",
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 5,
        "publisher": "京城高等商業學校",
        "publisher_ko": "경성고등상업학교",
        "library": "국립중앙도서관△",
        "school_id": 1844,
        "primaryname": "京城高等商業學校",
        "primaryname_ko": "경성고등상업학교"
    },
    {
        "book_id": 10876,
        "book_title": "京城高等商業學校一覽 大正12年度",
        "book_title_ko": "경성고등상업학교일람 대정12년도",
        "publish_date": "1923.10.05",
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 5,
        "publisher": "京城高等商業學校",
        "publisher_ko": "경성고등상업학교",
        "library": "국립중앙도서관△",
        "school_id": 52912,
        "primaryname": "京城高等商業學校",
        "primaryname_ko": "경성고등상업학교"
    },
    {
        "book_id": 10877,
        "book_title": "京城高等商業學校一覽 大正15年度",
        "book_title_ko": "경성고등상업학교일람 대정15년도",
        "publish_date": "1926.07.10",
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 10,
        "publisher": "京城高等商業學校",
        "publisher_ko": "경성고등상업학교",
        "library": "국립중앙도서관△",
        "school_id": 1844,
        "primaryname": "京城高等商業學校",
        "primaryname_ko": "경성고등상업학교"
    },
    {
        "book_id": 10877,
        "book_title": "京城高等商業學校一覽 大正15年度",
        "book_title_ko": "경성고등상업학교일람 대정15년도",
        "publish_date": "1926.07.10",
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 10,
        "publisher": "京城高等商業學校",
        "publisher_ko": "경성고등상업학교",
        "library": "국립중앙도서관△",
        "school_id": 52912,
        "primaryname": "京城高等商業學校",
        "primaryname_ko": "경성고등상업학교"
    },
    {
        "book_id": 10878,
        "book_title": "京城高等商業學校一覽 自大正13年至大正14年",
        "book_title_ko": "경성고등상업학교일람 자대정13년지대정14년",
        "publish_date": "1924.05.30",
        "publish_year": 1924,
        "publish_month": 5,
        "publish_day": 30,
        "publisher": "京城高等商業學校",
        "publisher_ko": "경성고등상업학교",
        "library": "국립중앙도서관△",
        "school_id": 1844,
        "primaryname": "京城高等商業學校",
        "primaryname_ko": "경성고등상업학교"
    },
    {
        "book_id": 10878,
        "book_title": "京城高等商業學校一覽 自大正13年至大正14年",
        "book_title_ko": "경성고등상업학교일람 자대정13년지대정14년",
        "publish_date": "1924.05.30",
        "publish_year": 1924,
        "publish_month": 5,
        "publish_day": 30,
        "publisher": "京城高等商業學校",
        "publisher_ko": "경성고등상업학교",
        "library": "국립중앙도서관△",
        "school_id": 52912,
        "primaryname": "京城高等商業學校",
        "primaryname_ko": "경성고등상업학교"
    },
    {
        "book_id": 10879,
        "book_title": "普成專門學校一覽 ",
        "book_title_ko": "보성전문학교일람 ",
        "publish_date": "1931.07.20",
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 20,
        "publisher": "普成專門學校",
        "publisher_ko": "보성전문학교",
        "library": "△",
        "school_id": 27158,
        "primaryname": "普成專門學校",
        "primaryname_ko": "보성전문학교"
    },
    {
        "book_id": 10879,
        "book_title": "普成專門學校一覽 ",
        "book_title_ko": "보성전문학교일람 ",
        "publish_date": "1931.07.20",
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 20,
        "publisher": "普成專門學校",
        "publisher_ko": "보성전문학교",
        "library": "△",
        "school_id": 52901,
        "primaryname": "普成專門學校",
        "primaryname_ko": "보성전문학교"
    },
    {
        "book_id": 10880,
        "book_title": "普成專門學校一覽 ",
        "book_title_ko": "보성전문학교일람 ",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成專門學校",
        "publisher_ko": "보성전문학교",
        "library": "△",
        "school_id": 27158,
        "primaryname": "普成專門學校",
        "primaryname_ko": "보성전문학교"
    },
    {
        "book_id": 10880,
        "book_title": "普成專門學校一覽 ",
        "book_title_ko": "보성전문학교일람 ",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成專門學校",
        "publisher_ko": "보성전문학교",
        "library": "△",
        "school_id": 52901,
        "primaryname": "普成專門學校",
        "primaryname_ko": "보성전문학교"
    },
    {
        "book_id": 10881,
        "book_title": "普成專門學校一覽 ",
        "book_title_ko": "보성전문학교일람 ",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成專門學校",
        "publisher_ko": "보성전문학교",
        "library": "△",
        "school_id": 27158,
        "primaryname": "普成專門學校",
        "primaryname_ko": "보성전문학교"
    },
    {
        "book_id": 10881,
        "book_title": "普成專門學校一覽 ",
        "book_title_ko": "보성전문학교일람 ",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成專門學校",
        "publisher_ko": "보성전문학교",
        "library": "△",
        "school_id": 52901,
        "primaryname": "普成專門學校",
        "primaryname_ko": "보성전문학교"
    },
    {
        "book_id": 10882,
        "book_title": "私立普成法律商業學校校典一覽 ",
        "book_title_ko": "사립보성법률상업학교교전일람 ",
        "publish_date": "1915.00.00",
        "publish_year": 1915,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "",
        "publisher_ko": "",
        "library": "",
        "school_id": 52913,
        "primaryname": "普成法律商業學校",
        "primaryname_ko": "보성전문학교"
    },
    {
        "book_id": 10883,
        "book_title": "セブランス聯合醫學專門學校一覽 昭和11年",
        "book_title_ko": "セブランス연합의학전문학교일람 소화11년",
        "publish_date": "1936.07.20",
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 20,
        "publisher": "吳競善  セブランス聯合醫學專門學校",
        "publisher_ko": "오경선  セブランス연합의학전문학교",
        "library": "서울대△",
        "school_id": 19044,
        "primaryname": "セブランス聯合醫學專門學校",
        "primaryname_ko": "セブランス연합의학전문학교"
    },
    {
        "book_id": 10883,
        "book_title": "セブランス聯合醫學專門學校一覽 昭和11年",
        "book_title_ko": "セブランス연합의학전문학교일람 소화11년",
        "publish_date": "1936.07.20",
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 20,
        "publisher": "吳競善  セブランス聯合醫學專門學校",
        "publisher_ko": "오경선  セブランス연합의학전문학교",
        "library": "서울대△",
        "school_id": 52903,
        "primaryname": "セブランス聯合醫學專門學校",
        "primaryname_ko": "세브란스연합의학전문학교"
    },
    {
        "book_id": 10884,
        "book_title": "セブランス聯合醫學專門學校一覽 昭和3年10月",
        "book_title_ko": "セブランス연합의학전문학교일람 소화3년10월",
        "publish_date": "1928.11.05",
        "publish_year": 1928,
        "publish_month": 11,
        "publish_day": 5,
        "publisher": "セブランス聯合醫學專門學校",
        "publisher_ko": "セブランス연합의학전문학교",
        "library": "서울대△",
        "school_id": 19044,
        "primaryname": "セブランス聯合醫學專門學校",
        "primaryname_ko": "セブランス연합의학전문학교"
    },
    {
        "book_id": 10884,
        "book_title": "セブランス聯合醫學專門學校一覽 昭和3年10月",
        "book_title_ko": "セブランス연합의학전문학교일람 소화3년10월",
        "publish_date": "1928.11.05",
        "publish_year": 1928,
        "publish_month": 11,
        "publish_day": 5,
        "publisher": "セブランス聯合醫學專門學校",
        "publisher_ko": "セブランス연합의학전문학교",
        "library": "서울대△",
        "school_id": 52903,
        "primaryname": "セブランス聯合醫學專門學校",
        "primaryname_ko": "세브란스연합의학전문학교"
    },
    {
        "book_id": 10885,
        "book_title": "セブランス聯合醫學專門學校一覽 昭和9年",
        "book_title_ko": "セブランス연합의학전문학교일람 소화9년",
        "publish_date": "1934.11.18",
        "publish_year": 1934,
        "publish_month": 11,
        "publish_day": 18,
        "publisher": "吳競善  セブランス聯合醫學專門學校",
        "publisher_ko": "오경선  セブランス연합의학전문학교",
        "library": "서울대;연세대△",
        "school_id": 19044,
        "primaryname": "セブランス聯合醫學專門學校",
        "primaryname_ko": "セブランス연합의학전문학교"
    },
    {
        "book_id": 10885,
        "book_title": "セブランス聯合醫學專門學校一覽 昭和9年",
        "book_title_ko": "セブランス연합의학전문학교일람 소화9년",
        "publish_date": "1934.11.18",
        "publish_year": 1934,
        "publish_month": 11,
        "publish_day": 18,
        "publisher": "吳競善  セブランス聯合醫學專門學校",
        "publisher_ko": "오경선  セブランス연합의학전문학교",
        "library": "서울대;연세대△",
        "school_id": 52903,
        "primaryname": "セブランス聯合醫學專門學校",
        "primaryname_ko": "세브란스연합의학전문학교"
    },
    {
        "book_id": 10886,
        "book_title": "延禧專門學校一覽 (昭和14年度)",
        "book_title_ko": "연희전문학교일람 (소화14년도)",
        "publish_date": "1939.07.20",
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 20,
        "publisher": "H.H.언더우드  延禧專門學校",
        "publisher_ko": "H.H.언더우드  연희전문학교",
        "library": "서울대△",
        "school_id": 19045,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10886,
        "book_title": "延禧專門學校一覽 (昭和14年度)",
        "book_title_ko": "연희전문학교일람 (소화14년도)",
        "publish_date": "1939.07.20",
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 20,
        "publisher": "H.H.언더우드  延禧專門學校",
        "publisher_ko": "H.H.언더우드  연희전문학교",
        "library": "서울대△",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10887,
        "book_title": "延禧專門學校一覽 (昭和15年度)",
        "book_title_ko": "연희전문학교일람 (소화15년도)",
        "publish_date": "1940.07.01",
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 1,
        "publisher": "H.H.언더우드  延禧專門學校",
        "publisher_ko": "H.H.언더우드  연희전문학교",
        "library": "서울대△",
        "school_id": 19045,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10887,
        "book_title": "延禧專門學校一覽 (昭和15年度)",
        "book_title_ko": "연희전문학교일람 (소화15년도)",
        "publish_date": "1940.07.01",
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 1,
        "publisher": "H.H.언더우드  延禧專門學校",
        "publisher_ko": "H.H.언더우드  연희전문학교",
        "library": "서울대△",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10888,
        "book_title": "(梨花女子專門學校;梨花保育學校) 梨花女子專門梨花保育學校一覽 (昭和12年)",
        "book_title_ko": "(이화여자전문학교;이화보육학교) 이화여자전문이화보육학교일람 (소화12년)",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "梨花女子專門梨花保育學校",
        "publisher_ko": "이화여자전문이화보육학교",
        "library": "",
        "school_id": 53000,
        "primaryname": "梨花女子專門梨花保育學校",
        "primaryname_ko": "이화여자전문이화보육학교"
    },
    {
        "book_id": 10888,
        "book_title": "(梨花女子專門學校;梨花保育學校) 梨花女子專門梨花保育學校一覽 (昭和12年)",
        "book_title_ko": "(이화여자전문학교;이화보육학교) 이화여자전문이화보육학교일람 (소화12년)",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "梨花女子專門梨花保育學校",
        "publisher_ko": "이화여자전문이화보육학교",
        "library": "",
        "school_id": 52906,
        "primaryname": "梨花女子專門學校;梨花保育學校",
        "primaryname_ko": "이화여자전문학교;이화보육학교"
    },
    {
        "book_id": 10889,
        "book_title": "水原高等農林學校一覽 ",
        "book_title_ko": "수원고등농림학교일람 ",
        "publish_date": "1923.10.30",
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 30,
        "publisher": "水原高等農林學校",
        "publisher_ko": "수원고등농림학교",
        "library": "국립중앙도서관△",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10890,
        "book_title": "水原高等農林學校一覽 (昭和5年)",
        "book_title_ko": "수원고등농림학교일람 (소화5년)",
        "publish_date": "1930.00.00",
        "publish_year": 1930,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "",
        "publisher_ko": "",
        "library": "서울대",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10891,
        "book_title": "朝鮮總督府水原高等農林學校要覽 ",
        "book_title_ko": "조선총독부수원고등농림학교요람 ",
        "publish_date": "1936.00.00.",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "水原高等農林學校",
        "publisher_ko": "수원고등농림학교",
        "library": "서울대",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10892,
        "book_title": "朝鮮總督府水原高等農林學校要覽 ",
        "book_title_ko": "조선총독부수원고등농림학교요람 ",
        "publish_date": "1937.00.00.",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "水原高等農林學校",
        "publisher_ko": "수원고등농림학교",
        "library": "서울대",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10893,
        "book_title": "朝鮮總督府水原高等農林學校要覽 ",
        "book_title_ko": "조선총독부수원고등농림학교요람 ",
        "publish_date": "1938.00.00.",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "水原高等農林學校",
        "publisher_ko": "수원고등농림학교",
        "library": "서울대",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10894,
        "book_title": "朝鮮總督府水原高等農林學校要覽 ",
        "book_title_ko": "조선총독부수원고등농림학교요람 ",
        "publish_date": "1939.00.00.",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "水原高等農林學校",
        "publisher_ko": "수원고등농림학교",
        "library": "서울대",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10895,
        "book_title": "朝鮮總督府水原高等農林學校要覽 ",
        "book_title_ko": "조선총독부수원고등농림학교요람 ",
        "publish_date": "1940.00.00.",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "水原高等農林學校",
        "publisher_ko": "수원고등농림학교",
        "library": "서울대",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10896,
        "book_title": "朝鮮總督府水原高等農林學校要覽 ",
        "book_title_ko": "조선총독부수원고등농림학교요람 ",
        "publish_date": "1941.00.00.",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "水原高等農林學校",
        "publisher_ko": "수원고등농림학교",
        "library": "서울대",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10897,
        "book_title": "朝鮮總督府水原高等農林學校要覽 ",
        "book_title_ko": "조선총독부수원고등농림학교요람 ",
        "publish_date": "1942.00.00.",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "水原高等農林學校",
        "publisher_ko": "수원고등농림학교",
        "library": "서울대",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10898,
        "book_title": "朝鮮總督府水原高等農林學校一覽 ",
        "book_title_ko": "조선총독부수원고등농림학교일람 ",
        "publish_date": "1931.09.10",
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 10,
        "publisher": "朝鮮總督府水原高等農林學校",
        "publisher_ko": "조선총독부수원고등농림학교",
        "library": "국립중앙도서관;서울대△",
        "school_id": 53001,
        "primaryname": "朝鮮總督府水原高等農林學校",
        "primaryname_ko": "조선총독부수원고등농림학교"
    },
    {
        "book_id": 10898,
        "book_title": "朝鮮總督府水原高等農林學校一覽 ",
        "book_title_ko": "조선총독부수원고등농림학교일람 ",
        "publish_date": "1931.09.10",
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 10,
        "publisher": "朝鮮總督府水原高等農林學校",
        "publisher_ko": "조선총독부수원고등농림학교",
        "library": "국립중앙도서관;서울대△",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10899,
        "book_title": "朝鮮總督府水原高等農林學校一覽 ",
        "book_title_ko": "조선총독부수원고등농림학교일람 ",
        "publish_date": "1934.10.28",
        "publish_year": 1934,
        "publish_month": 10,
        "publish_day": 28,
        "publisher": "水原高等農林學校",
        "publisher_ko": "수원고등농림학교",
        "library": "서울대;일본국립국회도서관 링크△",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10906,
        "book_title": "中央佛敎專門學校一覽 (昭和10年)",
        "book_title_ko": "중앙불교전문학교일람 (소화10년)",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대",
        "school_id": 53002,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10906,
        "book_title": "中央佛敎專門學校一覽 (昭和10年)",
        "book_title_ko": "중앙불교전문학교일람 (소화10년)",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10907,
        "book_title": "中央佛敎專門學校一覽 (昭和11年)",
        "book_title_ko": "중앙불교전문학교일람 (소화11년)",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대△",
        "school_id": 53002,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10907,
        "book_title": "中央佛敎專門學校一覽 (昭和11年)",
        "book_title_ko": "중앙불교전문학교일람 (소화11년)",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대△",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10908,
        "book_title": "中央佛敎專門學校一覽 (昭和12年)",
        "book_title_ko": "중앙불교전문학교일람 (소화12년)",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대△",
        "school_id": 53002,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10908,
        "book_title": "中央佛敎專門學校一覽 (昭和12年)",
        "book_title_ko": "중앙불교전문학교일람 (소화12년)",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대△",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10909,
        "book_title": "中央佛敎專門學校一覽 (昭和13年)",
        "book_title_ko": "중앙불교전문학교일람 (소화13년)",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대△",
        "school_id": 53002,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10909,
        "book_title": "中央佛敎專門學校一覽 (昭和13年)",
        "book_title_ko": "중앙불교전문학교일람 (소화13년)",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대△",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10910,
        "book_title": "中央佛敎專門學校一覽 (昭和8年)",
        "book_title_ko": "중앙불교전문학교일람 (소화8년)",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대",
        "school_id": 53002,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10910,
        "book_title": "中央佛敎專門學校一覽 (昭和8年)",
        "book_title_ko": "중앙불교전문학교일람 (소화8년)",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校",
        "publisher_ko": "중앙불교전문학교",
        "library": "서울대",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10911,
        "book_title": "惠化專門學校一覽 (昭和16年度)",
        "book_title_ko": "혜화전문학교일람 (소화16년도)",
        "publish_date": "1941.06.14",
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 14,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "△",
        "school_id": 27161,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10911,
        "book_title": "惠化專門學校一覽 (昭和16年度)",
        "book_title_ko": "혜화전문학교일람 (소화16년도)",
        "publish_date": "1941.06.14",
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 14,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "△",
        "school_id": 52914,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10912,
        "book_title": "(中央佛敎專門學校) 會員一覽 ",
        "book_title_ko": "(중앙불교전문학교) 회원일람 ",
        "publish_date": "1928.00.00.",
        "publish_year": 1928,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 校友會",
        "publisher_ko": "중앙불교전문학교 교우회",
        "library": "",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10913,
        "book_title": "(中央佛敎專門學校) 會員一覽 ",
        "book_title_ko": "(중앙불교전문학교) 회원일람 ",
        "publish_date": "1929.00.00.",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 校友會",
        "publisher_ko": "중앙불교전문학교 교우회",
        "library": "",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10914,
        "book_title": "(中央佛敎專門學校) 會員一覽 ",
        "book_title_ko": "(중앙불교전문학교) 회원일람 ",
        "publish_date": "1931.00.00.",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 校友會",
        "publisher_ko": "중앙불교전문학교 교우회",
        "library": "",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10915,
        "book_title": "(中央佛敎專門學校) 會員一覽 ",
        "book_title_ko": "(중앙불교전문학교) 회원일람 ",
        "publish_date": "1933.00.00.",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 校友會",
        "publisher_ko": "중앙불교전문학교 교우회",
        "library": "",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10916,
        "book_title": "(中央佛敎專門學校) 會員一覽 ",
        "book_title_ko": "(중앙불교전문학교) 회원일람 ",
        "publish_date": "1935.00.00.",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 校友會",
        "publisher_ko": "중앙불교전문학교 교우회",
        "library": "",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10917,
        "book_title": "(中央佛敎專門學校) 會員一覽 ",
        "book_title_ko": "(중앙불교전문학교) 회원일람 ",
        "publish_date": "1936.00.00.",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 校友會",
        "publisher_ko": "중앙불교전문학교 교우회",
        "library": "",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10918,
        "book_title": "(中央佛敎專門學校) 會員一覽 ",
        "book_title_ko": "(중앙불교전문학교) 회원일람 ",
        "publish_date": "1937.00.00.",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 校友會",
        "publisher_ko": "중앙불교전문학교 교우회",
        "library": "",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10919,
        "book_title": "(中央佛敎專門學校) 會員一覽 ",
        "book_title_ko": "(중앙불교전문학교) 회원일람 ",
        "publish_date": "1939.00.00.",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 校友會",
        "publisher_ko": "중앙불교전문학교 교우회",
        "library": "",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10920,
        "book_title": "(中央佛敎專門學校) 會員一覽 ",
        "book_title_ko": "(중앙불교전문학교) 회원일람 ",
        "publish_date": "1949.00.00.",
        "publish_year": 1949,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 校友會",
        "publisher_ko": "중앙불교전문학교 교우회",
        "library": "",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10921,
        "book_title": "平壤醫學專門學校一覽 (昭和9年)",
        "book_title_ko": "평양의학전문학교일람 (소화9년)",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "平壤醫學專門學校",
        "publisher_ko": "평양의학전문학교",
        "library": "△",
        "school_id": 53003,
        "primaryname": "平壤醫學專門學校",
        "primaryname_ko": "평양의학전문학교"
    },
    {
        "book_id": 10921,
        "book_title": "平壤醫學專門學校一覽 (昭和9年)",
        "book_title_ko": "평양의학전문학교일람 (소화9년)",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "平壤醫學專門學校",
        "publisher_ko": "평양의학전문학교",
        "library": "△",
        "school_id": 52915,
        "primaryname": "平壤醫學專門學校",
        "primaryname_ko": "평양의학전문학교"
    },
    {
        "book_id": 10922,
        "book_title": "平壤醫學專門學校一覽 (昭和8年)",
        "book_title_ko": "평양의학전문학교일람 (소화8년)",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "平壤醫學專門學校",
        "publisher_ko": "평양의학전문학교",
        "library": "△",
        "school_id": 53003,
        "primaryname": "平壤醫學專門學校",
        "primaryname_ko": "평양의학전문학교"
    },
    {
        "book_id": 10922,
        "book_title": "平壤醫學專門學校一覽 (昭和8年)",
        "book_title_ko": "평양의학전문학교일람 (소화8년)",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "平壤醫學專門學校",
        "publisher_ko": "평양의학전문학교",
        "library": "△",
        "school_id": 52915,
        "primaryname": "平壤醫學專門學校",
        "primaryname_ko": "평양의학전문학교"
    },
    {
        "book_id": 10966,
        "book_title": "(平壤中學校) 學校槪覽 創立10周年記念",
        "book_title_ko": "(평양중학교) 학교개람 창립10주년기념",
        "publish_date": "1926.09.20",
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 20,
        "publisher": "荒木孝次郞  平壤公立中學校",
        "publisher_ko": "황목효차랑  평양공립중학교",
        "library": "서울대△",
        "school_id": 28745,
        "primaryname": "平壤公立中學校",
        "primaryname_ko": "평양공립중학교;평양제1공립중학교"
    },
    {
        "book_id": 10966,
        "book_title": "(平壤中學校) 學校槪覽 創立10周年記念",
        "book_title_ko": "(평양중학교) 학교개람 창립10주년기념",
        "publish_date": "1926.09.20",
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 20,
        "publisher": "荒木孝次郞  平壤公立中學校",
        "publisher_ko": "황목효차랑  평양공립중학교",
        "library": "서울대△",
        "school_id": 52931,
        "primaryname": "平壤中學校",
        "primaryname_ko": "평양중학교"
    }

]

export default SchoolCatalogueData;